import { render, staticRenderFns } from "./SelectionList.vue?vue&type=template&id=49b49320&scoped=true&"
import script from "./SelectionList.vue?vue&type=script&lang=js&"
export * from "./SelectionList.vue?vue&type=script&lang=js&"
import style0 from "./SelectionList.vue?vue&type=style&index=0&id=49b49320&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b49320",
  null
  
)

export default component.exports